
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RoadmapPage from "../pages/roadmap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/roadmap",
    element: <RoadmapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
